
import { Component, Prop, Vue } from 'vue-property-decorator'
import AlarmCountModel from '../alarm-count.model'

@Component
export default class AlarmCountList extends Vue {
  @Prop({
    default: () => [
      {
        alarmTypeId: 100001,
        alarmDescription: '电池从平台区运转至缓存位超时',
        alarmRaiseCount: 18,
        alarmDiagnosis: [
          {
            diagnosisId: 111000,
            diagonosisDescription: '到位传感器实际已触发',
            diagnosisCount: 5
          },
          {
            diagnosisId: 111000,
            diagonosisDescription: '告警前25s均无传感器log记录，电池未出平台区',
            diagnosisCount: 5
          },
          {
            diagnosisId: 111000,
            diagonosisDescription: '电池卡在减速到到位之间或者原因异常',
            diagnosisCount: 5
          }
        ]
      },
      {
        alarmTypeId: 100001,
        alarmDescription: '电池从平台区运转至缓存位超时',
        alarmRaiseCount: 13,
        alarmDiagnosis: [
          {
            diagnosisId: 111000,
            diagonosisDescription: '到位传感器实际已触发',
            diagnosisCount: 5
          },
          {
            diagnosisId: 111000,
            diagonosisDescription: '告警前25s均无传感器log记录，电池未出平台区',
            diagnosisCount: 5
          },
          {
            diagnosisId: 111000,
            diagonosisDescription: '电池卡在减速到到位之间或者原因异常',
            diagnosisCount: 5
          }
        ]
      }
    ]
  })
  private list!: AlarmCountModel[]

  get maxAlarmRaiseCount() {
    let max = 0
    this.list.forEach((elem) => {
      max = Math.max(elem.alarmRaiseCount, max)
    })
    return max * 1.05
  }
}
